import { render } from "./CleanRoom.vue?vue&type=template&id=9f90d14c&scoped=true"
const script = {}

import "./CleanRoom.vue?vue&type=style&index=0&id=9f90d14c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9f90d14c"

export default script